import 'babel-polyfill';

import $ from 'jquery';
import Flickity from 'flickity';

import debug from 'debug';
import { PLUGIN_NAME } from './index';

const log = debug('components/epi-blocks/banner-hero:flickity');

class BannerHeroBlockSlider {
	constructor(element, options) {
		log('construct', element, options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.init();
		this.watch();

		log(this.element);
	}

	init() {
		Flickity.prototype._createResizeClass = function() {
			this.element.classList.add('flickity-resize');
		};
		Flickity.createMethods.push('_createResizeClass');
		const resize = Flickity.prototype.resize;

		Flickity.prototype.resize = function() {
			this.element.classList.remove('flickity-resize');
			resize.call(this);
			this.element.classList.add('flickity-resize');
		};

		this.carousel = new Flickity(this.element, {
			arrowShape: this.options.arrowShape,
			percentPosition: false,
			cellSelector: this.options.cellSelector,
			autoPlay: this.options.autoPlay,
			friction: 0.5,
			// watchCSS: true,
			// groupCells: true,
			initialIndex: 0,
			on: {
				ready: this.onReady.bind(this)
			}
		});
	}

	watch(){
		this.carousel.on('change', this.onChange.bind(this));
	}

	onReady(){
		log('Flickity ready');
		this.setInstance();
		this.updateTabindex();
	}

	setInstance () {
		this.carousel = Flickity.data(this.element);
		return this.carousel;
	}

	onChange(index){
		log('onchange index', index);
		this.updateTabindex();
		this.syncThemeData();

		const changeEvent = new CustomEvent(this.options.onChangeEvent, {
			bubbles: true,
			cancelable: true,
			// detail: {}
		});

		this.element.dispatchEvent(changeEvent);
	}

	syncThemeData(){
		log('selected', this.carousel.selectedElement);
		const currentSlide = this.carousel.selectedElement;
		const themeClass = currentSlide.dataset['bannerHeroBlockSlider-ThemeClass'];

		log('themeClass', themeClass);

		// apply same value to corresponding attr on slider
		this.element.dataset['bannerHeroBlockSliderThemeClass'] = themeClass;
	}

	updateTabindex(){
		log('updateTabindex');

		const cells = this.carousel.getCellElements();
		const selectedCells = this.carousel.selectedElements;
		log('selectedElements', selectedCells);

		const unselectedCells = $(cells).not(selectedCells);
		log('unselectedCells', unselectedCells);

		this.disableLinks(unselectedCells);
		this.enableLinks(selectedCells);

	}

	disableLinks(parentElements){
		$(parentElements).find('a').attr('tabindex','-1');
	}

	enableLinks(parentElements){
		$(parentElements).find('a').removeAttr('tabindex');
	}
}

BannerHeroBlockSlider.DEFAULTS = {
	onChangeEvent: "sliderChange",
	cellSelector: '',
	autoPlay: false
};

// plugin(PLUGIN_NAME, BannerHeroBlockSlider);

export default BannerHeroBlockSlider;



// WEBPACK FOOTER //
// ./project/client/src/site__def/components/epi-blocks/banner-hero/banner-hero-block-slider.js